import React from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import {
  CustomLinkComponent,
  DynamicTag,
  PageActionPlaceHolder,
  Spinner
} from 'msp-components'
import { useAccount } from 'msp-integrations'

import AddressDisplay from '@/components/atoms/AddressDisplay/AddressDisplay'

import translations from './AccountOverviewAddress.constants'
import * as S from './AccountOverviewAddress.styles'

export type AccountOverviewAddressProps = {
  className?: string
}

const AccountOverviewAddress = ({
  className = ''
}: AccountOverviewAddressProps) => {
  const { formatMessage } = useIntl()
  const {
    customer: { addresses = [], isInitialized }
  } = useAccount()
  const pageLink = '/account/addresses'

  return (
    <div className={twMerge(S.MainWrapper, className)}>
      <DynamicTag componentTagName='Headline' tag='h6' className={S.Headline}>
        {formatMessage(translations.headline)}
      </DynamicTag>
      {!isInitialized && <Spinner />}
      {isInitialized && addresses && addresses.length === 0 && (
        <PageActionPlaceHolder text={formatMessage(translations.noAddresses)} />
      )}
      {isInitialized && addresses && addresses.length > 0 && (
        <AddressDisplay address={addresses[0]} />
      )}
      <CustomLinkComponent href={pageLink} className={S.Link}>
        {formatMessage(translations.headline)}
      </CustomLinkComponent>
    </div>
  )
}

export default AccountOverviewAddress
